import type { ReactNode } from 'react';
import styles from './Button.module.css';

export interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'secondaryLight' | 'link';
  size?: 'small' | 'large';
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'large',
  href,
  onClick,
  disabled = false,
  className,
  children,
}: ButtonProps) {
  const cls = `${styles.button} ${styles[variant]} ${styles[size]} ${className ?? ''}`;

  if (href) {
    return (
      <a data-crd-id="r2.bq-button" data-crd-layer="r2" href={href} className={cls} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button
      data-crd-id="r2.bq-button"
      data-crd-layer="r2"
      type="button"
      className={cls}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
